// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1ZILQ","empty":"ModalGraph_empty__3rnpG"};